export default __webpack_public_path__ + "69a18da78b6597baebe958c9271f00e8.svg";